import { useEffect } from "react";
import { Provider } from "react-redux";
import { ThemeProvider } from "styled-components";

import "services/firebase";
import MainRouter from "features/routing/components/mainRouter";
import store from "services/redux/createStore";
import listenToAuthState from "features/auth/actions/auth.listenToAuthState";
import theme from "config/styles/theme";
import { ErrorBoundary } from "@sentry/react";
import ErrorFallback from "features/errorCatching/components/ErrorFallback";

function App() {
    useEffect(() => {
        const unsubscribe = store.dispatch<any>(listenToAuthState());
        return () => unsubscribe();
    }, []);

    return (
        <ErrorBoundary
            fallback={ErrorFallback}
            beforeCapture={(scope) => {
                scope.setTag("location", "root");
            }}
        >
            <Provider store={store}>
                <ThemeProvider theme={theme}>
                    <MainRouter />
                </ThemeProvider>
            </Provider>
        </ErrorBoundary>
    );
}

export default App;
